import React, { useState, useEffect, useRef, useCallback } from "react";
import "./index.css"; // Import the CSS file
import AboutWork from "../work";

export default function Carousel({ children }) {
  

  
  const [dynamicHeight, setDynamicHeight] = useState(null);
  const [translateX, setTranslateX] = useState(0);

  const containerRef = useRef(null);
  const objectRef = useRef(null);

  const calcDynamicHeight = (objectWidth) => {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    return objectWidth - vw + vh + 150;
  };

  const handleDynamicHeight = useCallback(() => {
    const objectWidth = objectRef.current.scrollWidth;
    const dynamicHeight = calcDynamicHeight(objectWidth);
    setDynamicHeight(dynamicHeight);
  }, []);

  const applyScrollListener = () => {
    const handleScroll = () => {
      const offsetTop = -containerRef.current.offsetTop;
      setTranslateX(offsetTop);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  };

  useEffect(() => {
    handleDynamicHeight();
    window.addEventListener("resize", handleDynamicHeight);
    const removeScrollListener = applyScrollListener();
    return () => {
      removeScrollListener();
      window.removeEventListener("resize", handleDynamicHeight);
    };
  }, [handleDynamicHeight]);

  return (
    <div id="Works" className="tall-outer-container" style={{ height: `${dynamicHeight}px` }}>
      <div className="sticky-inner-container" ref={containerRef}>
        <AboutWork/>
        <div className="horizontal-translate-container" style={{ transform: `translateX(${translateX}px)` }} ref={objectRef}>
          {children}
        </div>
      </div>
    </div>
  );
}
